import React from 'react';

function Dashboard() {
    return (<>
        <h1 className='text-center text-4xl font-bold'>Dashboard Comming Soon</h1>
    </>);
}

export default Dashboard;